import React from "react";

const InfoBlock = ({
  title = '',
  header = null,
  isTwoRow = false,
  className = '',
  children
}) => {

  return (<div className={`infoblock ${className}`}>
    <div className={`infoblock__header ${isTwoRow ? 'infoblock__header-two-row' : ''}`}>
      <div className="infoblock__title">{title}</div>
      <div className="infoblock__title-action">{header}</div>
    </div>
    <div className="infoblock__line"></div>
    {children}
  </div>)
};

export default InfoBlock;